import {post, deleteMethod, formatUrl} from '../../../utils/request'
import {
  LOVE_TALENT_EMPLOYER,
  SAVE_TALENT_EMPLOYER,
  LOVE_TALENT_TALENT
} from '../../../utils/urls'

const actions = {
  loveTalent: function(context, payload) {
    let url = formatUrl(LOVE_TALENT_EMPLOYER, payload.params)
    if (payload.body.is_love === 'y') {
      return post(url)
    } else {
      return deleteMethod(url)
    }
  },
  loveTalentByTalent: function(context, payload) {
    let url = formatUrl(LOVE_TALENT_TALENT, payload.params)
    if (payload.body.is_love === 'y') {
      return post(url)
    } else {
      return deleteMethod(url)
    }
  },
  saveTalent: function(context, payload) {
    let url = formatUrl(SAVE_TALENT_EMPLOYER, payload.params)
    if (payload.body.is_save === 'y') {
      return post(url)
    } else {
      return deleteMethod(url)
    }
  }
}

export default actions
